import Button from '@/Components/Button';
import FileUpload from '@/Components/Forms/FileUpload';
import {
  ArrowDownOnSquareIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

/**
 * Upload panel component for image uploads
 * @param {Object} props - Component props
 * @returns {JSX.Element} Upload panel
 */
const UploadPanel = ({
  theme,
  noVision,
  fileSelected,
  onInteraction,
  onBadInteraction,
  onUploaded,
}) => {
  return (
    <>
      <div
        className={`${
          theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
        } text-base font-medium mb-1`}
      >
        Upload an Image
      </div>

      <div className="relative">
        <div className={`${noVision && 'opacity-20 blur-[1px] select-none'}`}>
          <FileUpload
            onUploaded={(uploadedFiles) => {
              console.log(uploadedFiles);
              const filesWithImageType = uploadedFiles.map((file) => ({
                ...file,
                type: 'image',
              }));
              onUploaded(filesWithImageType);
            }}
            type=".png, .jpeg, .jpg, .webp, .gif"
          />
        </div>

        {noVision && (
          <div
            className={`absolute px-4 top-0 left-0 ${
              theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
            } w-full h-full flex justify-center items-center select-none`}
          >
            <SparklesIcon className="h-6 w-6 mr-5" />
            <div
              className={`text-center not-italic ${
                theme === 'dark' ? 'text-crystal-bell' : 'text-raisin-black'
              }`}
            >
              Choose a{' '}
              <span
                onClick={() =>
                  onBadInteraction({
                    reason: 'bad model',
                  })
                }
                className="text-nue-blue font-semibold underline cursor-pointer"
              >
                model (LLM) like GPT-4o - (Nov-20)
              </span>{' '}
              to enable image uploads.
            </div>
          </div>
        )}
      </div>

      <div className="text-raisin-black dark:text-crystal-bell text-xs font-normal mt-1">
        Images you upload will be read as input for your queries. Supported
        formats: PNG, JPEG, JPG, WebP, GIF.
      </div>

      <div className="flex justify-end w-full mt-4">
        <Button
          Icon={ArrowDownOnSquareIcon}
          title="Insert"
          disabled={fileSelected.length <= 0}
          onClick={() => onInteraction(fileSelected)}
          iconSize="w-[18px] h-[18px]"
          customRound="rounded-xl"
          customPaddig="px-4 py-2"
          customWeight="font-semibold"
          noUppercase
        />
      </div>
    </>
  );
};

export default UploadPanel;
